<template>
    <CommonBox title="Upload File" @close="$emit('close')" @submit="$emit('close')">
       <el-upload
			class="upload-demo"
			ref="upload"
			:action="$http.http.defaults.baseURL + 'uploadFileCertifications'"
			:headers="header"
			:data="resultData"
			:auto-upload="false"
			:multiple="true"
            :before-upload="beforeUpload"
			:file-list="fileList"
			:on-success="success"
		>
        <!-- 修改：把可选选项改成从数据库读取 -->
		<el-button style="margin-left:10px;" slot="trigger" size="small" type="primary">Select File</el-button>
        <br><br>
                <label style="margin-left:10px;display:inline-block;width:150px;">Product Category：</label>
                <el-select style="width:160px;" v-model="data.ProductCategory" @change="data.ProductModel=''" placeholder="">
                    <el-option
                        v-for="item in productCategoryList"
                        :key="item.ID"
                        :label="item.ProductCategory"
                        :value="item.ID">
                    </el-option>
                </el-select>
                <br><br>

                <label style="margin-left:10px;display:inline-block;width:150px;">Product Model：</label>
                <template>
                    <el-select style="width:160px;" v-model="data.ProductModel" placeholder="">
                        <el-option
                            v-for="item in productModelList"
                            :key="item.ID"
                            :label="item.ProductModel"
                            :value="item.ID">
                        </el-option>
                    </el-select>
               
                </template>
                <br><br>

                <label style="margin-left:10px;display:inline-block;width:150px;">Document Type：</label>
                <el-select style="width:160px;" v-model="data.DocumentType" placeholder="" @change="isCertification">
                    <el-option
                        v-for="item in documentTypeList"
                        :key="item.ID"
                        :label="item.DocumentType"
                        :value="item.ID">
                    </el-option>
                </el-select>
                <el-select v-if="isCertificationBlock" v-model="data.Certification" style="width:200px;margin-left:10px" placeholder=""  >
                    <el-option
                        v-for="item in certificationList"
                        :key="item.ID"
                        :label="item.DocumentType"
                        :value="item.ID"
                    >
                    </el-option>
                </el-select>
                <br><br>
        
		<el-button style="margin-left:10px;" size="small" type="success" @click="submitUpload">Upload to Server</el-button>
		</el-upload>
    </CommonBox>
</template>

<script>
import CommonBox from "@/components/common/CommonBox1.vue";
// import { certificationList } from "@/components/Certifications/data.js";
export default {
    components:{
        CommonBox
    },
    props:{
    },
    data () {
        return {
            header:{},
            productCategoryList:"",
            productModelList:"",
            documentTypeList:"",
            certificationList:[],
            data:{
                ProductCategory:"",
                ProductModel:"",
                DocumentType:"",
                Certification:""
            },
            resultData:{
                ProductCategory:"",
                ProductModel:"",
                DocumentType:""
            },
            isCertificationBlock:false,
            fileList:[]
        };
    },
    mounted () {
        this.header = {
            "x-auth-token":localStorage.getItem('producttoken')
        };
        this.$http.get("getAllDocumentsProductCategory",{},(data)=>{
            this.productCategoryList = data.data;
        });
        this.$http.get("getDocumentsProductModel",{},(data)=>{
            this.productModelList = data.data;
        });
        this.$http.get("getAllDocumentsDocumentType",{},(data)=>{
            this.documentTypeList = data.data;
        });
        this.$http.get("/getChildOfDocumentType", {pid: 3}, (resp)=>{
            if (resp.code == 0) {
                let data = resp.data
                if (data.length > 0) {
                    this.certificationList = data;
                }
            }
        });
        
    },
    methods:{
        submitUpload () {
            this.resultData.ProductCategory = this.data.ProductCategory;
            this.resultData.ProductModel = this.data.ProductModel;

            if(this.data.DocumentType !== '3'|| this.data.DocumentType === '3' && this.data.Certification === 'all')  //不选Certification
              {  this.resultData.DocumentType = this.data.DocumentType; 
           } else{   //选Certification
                var numReg = /^[0-9]*$/;
                var numRe = new RegExp(numReg);
                if(!numRe.test(this.data.Certification)){
                     this.resultData.DocumentType =9;
                }else{
                this.resultData.DocumentType = this.data.Certification;
                }
            }

            this.$refs.upload.submit();
        },
        success (response) {
            if(response.code === 0) {
                this.$baseNotice.message(response.msg);
                this.$emit("success");
            }else{
                this.$baseNotice.message(response.msg,"error");
            }
        },
        beforeUpload (file) {
            if(file.size > 100 * 1024 * 1024) {
                this.$message.error("The size of "+file.name+" exceeds 100M !");
                return false;
            }
        },
        isCertification () {
            if(this.data.DocumentType === '3') {
                this.data.Certification = 'CE',
                this.isCertificationBlock = true;
            }
            else
                this.isCertificationBlock = false;
        }
    },
    watch:{
        'data.ProductCategory'() {
            this.$http.get("getAllDocumentsProductModel",{CategoryID:this.data.ProductCategory},(data)=>{
                this.productModelList = data.data;
            
            });
            
        },
        'data.DocumentType'() {
            if(this.data.DocumentType==="3") {
                this.isCertificationBlock=true;

            }
            
        }      
    }
};
</script>
